export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className={compact ? 'brand brand--compact' : 'brand'}>
      <img src="/logo-mark.png" width="88" height="88" alt="" />
      <div className="brand__type">
        <strong>Acchey<span>Rishtey</span></strong>
        <small>Meaningful matches</small>
      </div>
    </div>
  );
}
